module.exports = __webpack_public_path__ + "assets/img/bdef0cdbee33f600a693d79a6f67d476.svg";